"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Responses = {
  status_error: {
    nl: 'Er is iets mis gelopen',
    fr: 'Quelque chose a mal tourné',
    en: 'Something went wrong',
    de: 'Etwas ist schiefgelaufen'
  },
  status_400: {
    nl: 'Ongeldige aanvraag (400)',
    fr: 'Demande invalide (400)',
    en: 'Invalid request (400)',
    de: 'Ungültige Anfrage (400)'
  },
  status_401: {
    nl: 'Ongeldige toegang tot gegevens (401)',
    fr: 'Accès non valide aux données (401)',
    en: 'Invalid access to data (401)',
    de: 'Ungültiger Zugriff auf Daten (401)'
  },
  status_403: {
    nl: 'Ongeldige machtigingen (403)',
    fr: 'Autorisations invalides (403)',
    en: 'Invalid permissions (403)',
    de: 'Ungültige Berechtigungen (403)'
  },
  status_404: {
    nl: 'Kan data niet vinden (404)',
    fr: 'Impossible de trouver les données (404)',
    en: 'Cannot find data (404)',
    de: 'Daten nicht gefunden (404)'
  },
  status_405: {
    nl: 'Methode niet toegelaten (405)',
    fr: 'Méthode non autorisée (405)',
    en: 'Method not allowed (405)',
    de: 'Methode nicht erlaubt (405)'
  },
  status_408: {
    nl: 'Verzoek afgebroken wegens lange duurtijd (408)',
    fr: "Demande abandonnée en raison d'une longue durée (408)",
    en: 'Request aborted due to long duration (408)',
    de: 'Anfrage aufgrund langer Dauer abgebrochen (408)'
  },
  status_500: {
    nl: 'Er is iets fout gelopen; het ligt niet aan jou, maar aan ons (500)',
    fr: "Quelque chose a mal tourné; ce n'est pas à vous mais à nous (500)",
    en: "Something went wrong; it's not you, but us (500)",
    de: 'Etwas ist schiefgelaufen; es liegt nicht an Ihnen, sondern an uns (500)'
  }
};
var _default = Responses;
exports["default"] = _default;